import css from 'styled-jsx/css';
import {
  colorHighlight,
  colorPalette,
  display,
  sansSerif
} from 'styles/css-constants';

export default css`
  .AmpEmailSignup__body {
    padding: 1rem;
    background-color: ${colorHighlight};
    color: #fff;
  }

  .AmpEmailSignup__desc {
    font-family: ${sansSerif};
    font-size: 14px;
    line-height: 1.4;
    text-align: center;
  }

  .AmpEmailSignup__email-input {
    grid-area: input;
    padding: 0.5rem;
    font-family: ${sansSerif};
    font-size: 16px;
    text-align: center;
  }

  .AmpEmailSignup__email-input:active + .AmpEmailSignup__label-name,
  .AmpEmailSignup__email-input:focus + .AmpEmailSignup__label-name,
  .AmpEmailSignup__email-input:valid + .AmpEmailSignup__label-name {
    display: none;
  }

  .AmpEmailSignup__form {
    padding: 1.5rem;
    background: linear-gradient(
      to bottom right,
      #fd525b 0%,
      #fd6a71 50%,
      ${colorHighlight} 50%,
      #fd5a64 100%
    );
  }

  .AmpEmailSignup__form fieldset {
    margin: 0;
    border: none;
    padding: 0;
  }

  .AmpEmailSignup__form input[type='submit'] {
    display: block;
    width: 100%;
    border: 1px solid #fff;
    padding: 0.5rem;
    background-color: transparent;
    color: #fff;
    font-family: ${sansSerif};
    font-size: 14px;
    letter-spacing: 0.05em;
    text-align: center;
    text-transform: uppercase;
  }

  .AmpEmailSignup__label {
    margin-bottom: 0.75rem;
    display: grid;
    grid-template: 'input';
    align-items: center;
  }

  .AmpEmailSignup__label-name {
    grid-area: input;
    z-index: 1;
    color: ${colorPalette.gray};
    font-family: ${sansSerif};
    font-size: 16px;
    letter-spacing: 0.05em;
    text-align: center;
    text-transform: uppercase;
    pointer-events: none;
  }

  .AmpEmailSignup__title {
    margin: 0 0 0.5rem;
    font-family: ${display};
    text-align: center;
  }
`;
